<app-date-input #dateInputComponent [value]="value?.date" (changed)="handleDateChange()"></app-date-input>

<app-time-input #timeInputComponent [value]="value?.time" (changed)="handleTimeChange()"></app-time-input>
